import * as _ from 'lodash';
// import moment from 'moment';
// import * as str from 'underscore.string';

export const TranformtionPolicyServerToClientFilterObject = {
    "name": "policyServerToClient",
    "filter": [() => {
        return (inputJson, metaData) => {
            var policy = angular.copy(inputJson);
            policy.environmentTypes = _.map(inputJson.environmentTypes , (env) => {
                delete env.$$hashKey;
                return env;
            });
            policy.dbs = metaData.dbTypes;
            if (policy.relationship == true)
                policy.relationship = { key: true, value: "Or" };
            else if (policy.relationship == false)
                policy.relationship = { key: false, value: "And" };
            if (inputJson.rules.length > 0) {
                //(rule) => { return rule.category.Value; }); to (rule) => { return rule.internalRule.category.Value; });
                let data = _.groupBy(inputJson.rules, (rule) => { return rule.internalRule.category.Value; });
                policy.selectedRulesIntoOther = [];
                for (var categoryItem in data) {
                    let category = {};
                    let count = 0;
                    category.label = categoryItem;
                    category.selected = false;
                    category.children = [];
                    _.each(data[categoryItem], (rule) => {
                        rule.label = `${rule.internalRule.name}  \xa0\xa0\xa0   (${rule.internalRule.createdBy})`;
                        rule.dbs = rule.internalRule.dbTypes;
                        rule.selected = (rule.isEnabled) ? true : false;
                        rule.isPositive = (rule.isPositive) ? true : false;
                        if (rule.selected)
                            count += 1;
                        category.children.push(rule);
                    });
                    if (count == category.children.length)
                        category.selected = true;
                    else if (count > 0)
                        category.__ivhTreeviewIndeterminate = true;
                    policy.selectedRulesIntoOther.push(category);
                }
            }
            return [policy];
        };
    }]
};



// WEBPACK FOOTER //
// ./src/app/authorized/policyEngine/transofromtions/trans.policyServerToClient.js